import { FC } from 'react';

interface ITicketErrorHeaderProps{}

const TicketErrorHeader: FC<ITicketErrorHeaderProps> = ()=>{
  return null;
}

export default TicketErrorHeader;